import {PlanTypeEnum} from 'presentation/constants';
import {BookingTypeEnum} from '../booking/constants';
import {useBookingConfirmationDrawer} from '../booking/hooks/useBookingConfirmationDrawer';
import {useNewAppointmentModalStore} from '../store/newAppointmentModalStore';
import {useAccountDataStore} from '../store/useAccountDataStateStore';

export function useHandleNewAppointment() {
	const {
		beneficiary: {tipoPlanoC},
	} = useAccountDataStore(store => store.accountData);

	const appointmentModalOpen = useNewAppointmentModalStore(state => state.newAppointmentModal);
	const setAppointmentModalOpen = useNewAppointmentModalStore(
		state => state.setNewAppointmentModal,
	);
	const isOdonto = tipoPlanoC === PlanTypeEnum.ODONTO;
	const {setSelectedServiceType, handleOpenBookingConfirmationDrawer} =
		useBookingConfirmationDrawer();

	const handleNewAppointment = () => {
		if (isOdonto) {
			setSelectedServiceType(BookingTypeEnum.ODONTO);
			handleOpenBookingConfirmationDrawer();
			return;
		}
		setAppointmentModalOpen(true);
	};

	return {
		appointmentModalOpen,
		setAppointmentModalOpen,
		handleNewAppointment,
	};
}
